// src/TrackPageView.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TrackPageView = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'pageview',
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};

export default TrackPageView;
